'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = exports.CheckboxLabel = exports.CheckboxMixedmark = exports.CheckboxCheckmarkPath = exports.CheckboxCheckmark = exports.CheckboxBackground = exports.CheckboxNativeControl = exports.CheckboxRoot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _mdc = require('@material/checkbox/dist/mdc.checkbox');

var _formfield = require('@rmwc/formfield');

var _formfield2 = _interopRequireDefault(_formfield);

var _base = require('@rmwc/base');

var _randomId = require('@rmwc/base/utils/randomId');

var _ripple = require('@rmwc/ripple');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxRoot = exports.CheckboxRoot = (0, _ripple.withRipple)({
  surface: false,
  unbounded: true
})((0, _base.simpleTag)({
  displayName: 'CheckboxRoot',
  classNames: function classNames(props) {
    return ['mdc-checkbox', {
      'mdc-checkbox--disabled': props.disabled
    }];
  },
  consumeProps: ['disabled']
}));

var CheckboxNativeControl = exports.CheckboxNativeControl = (0, _base.simpleTag)({
  displayName: 'CheckboxNativeControl',

  tag: 'input',
  classNames: 'mdc-checkbox__native-control',
  defaultProps: {
    type: 'checkbox'
  }
});

var CheckboxBackground = exports.CheckboxBackground = (0, _base.simpleTag)({
  displayName: 'CheckboxBackground',
  classNames: 'mdc-checkbox__background'
});

var CheckboxCheckmark = exports.CheckboxCheckmark = (0, _base.simpleTag)({
  displayName: 'CheckboxCheckmark',
  tag: 'svg',
  classNames: 'mdc-checkbox__checkmark',
  defaultProps: {
    viewBox: '0 0 24 24'
  }
});

var CheckboxCheckmarkPath = exports.CheckboxCheckmarkPath = (0, _base.simpleTag)({
  displayName: 'CheckboxCheckmarkPath',
  tag: 'path',
  classNames: 'mdc-checkbox__checkmark-path',
  defaultProps: {
    fill: 'none',
    stroke: 'white',
    d: 'M1.73,12.91 8.1,19.28 22.79,4.59'
  }
});

var CheckboxMixedmark = exports.CheckboxMixedmark = (0, _base.simpleTag)({
  displayName: 'CheckboxMixedmark',
  classNames: 'mdc-checkbox__mixedmark'
});

var CheckboxLabel = exports.CheckboxLabel = (0, _base.simpleTag)({
  displayName: 'CheckboxLabel',
  tag: 'label'
});

/**
 * A Checkbox component
 */

var Checkbox = exports.Checkbox = function (_FoundationComponent) {
  _inherits(Checkbox, _FoundationComponent);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    _this.generatedId = (0, _randomId.randomId)('checkbox');
    _this.createClassList('root_');
    _this.createPropsList('nativeCb_');
    return _this;
  }

  _createClass(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.nativeCbHandler_ = function () {
        return _this2.syncWithDOM(_this2.props);
      };
      this.nativeCb_.addEventListener('change', this.nativeCbHandler_);
      _get(Checkbox.prototype.__proto__ || Object.getPrototypeOf(Checkbox.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _get(Checkbox.prototype.__proto__ || Object.getPrototypeOf(Checkbox.prototype), 'componentWillUnmount', this).call(this);
      this.nativeCb_.removeEventListener('change', this.nativeCbHandler_);
    }
  }, {
    key: 'syncWithDOM',
    value: function syncWithDOM(nextProps) {
      if (nextProps.indeterminate !== this.nativeCb_.indeterminate) {
        this.nativeCb_.indeterminate = nextProps.indeterminate;
      }
    }
  }, {
    key: 'getDefaultFoundation',
    value: function getDefaultFoundation() {
      var _this3 = this;

      return new _mdc.MDCCheckboxFoundation({
        addClass: function addClass(className) {
          return _this3.classList.root_.add(className);
        },
        removeClass: function removeClass(className) {
          return _this3.classList.root_.remove(className);
        },
        setNativeControlAttr: function setNativeControlAttr(attr, value) {
          return _this3.propsList.nativeCb_.add(attr, value);
        },
        removeNativeControlAttr: function removeNativeControlAttr(attr) {
          return _this3.propsList.nativeCb_.remove(attr);
        },
        getNativeControl: function getNativeControl() {
          return _this3.nativeCb_;
        },
        isIndeterminate: function isIndeterminate() {
          return _this3.props.indeterminate;
        },
        isChecked: function isChecked() {
          return _this3.props.checked !== undefined ? _this3.props.checked : _this3.nativeCb_.checked;
        },
        hasNativeControl: function hasNativeControl() {
          return !!_this3.nativeCb_;
        },
        setNativeControlDisabled: function setNativeControlDisabled(disabled) {
          return _this3.nativeCb_.disabled = disabled;
        },
        forceLayout: function forceLayout() {
          return _this3.root_.offsetWidth;
        },
        isAttachedToDOM: function isAttachedToDOM() {
          return Boolean(_this3.root_.parentNode);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          _props$label = _props.label,
          label = _props$label === undefined ? '' : _props$label,
          id = _props.id,
          children = _props.children,
          indeterminate = _props.indeterminate,
          rest = _objectWithoutProperties(_props, ['label', 'id', 'children', 'indeterminate']);

      var labelId = id || this.generatedId;

      var checkbox = React.createElement(
        CheckboxRoot,
        {
          elementRef: function elementRef(ref) {
            return _this4.root_ = ref;
          },
          disabled: rest.disabled,
          className: this.classList.root_.get()
        },
        React.createElement(CheckboxNativeControl, Object.assign({}, this.propsList.nativeCb_.get(), {
          elementRef: function elementRef(ref) {
            return _this4.nativeCb_ = ref;
          },
          id: labelId
        }, rest)),
        React.createElement(
          CheckboxBackground,
          null,
          React.createElement(
            CheckboxCheckmark,
            null,
            React.createElement(CheckboxCheckmarkPath, null)
          ),
          React.createElement(CheckboxMixedmark, null)
        )
      );

      /**
       * We have to conditionally wrap our checkbox in a formfield
       * If we have a label
       */
      if (label.length || children) {
        return React.createElement(
          _formfield2.default,
          null,
          checkbox,
          React.createElement(
            CheckboxLabel,
            { id: labelId + 'label', htmlFor: labelId },
            label,
            children
          )
        );
      } else {
        return checkbox;
      }
    }
  }]);

  return Checkbox;
}(_base.FoundationComponent);

Object.defineProperty(Checkbox, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'Checkbox'
});
exports.default = Checkbox;
